import React, { FC } from "react";
import { Notification } from "@telia/teddy";
import { MAX_AGE_BARN, MAX_AGE_UNG } from "../../../../../../constants";
import TEXT from "../../../text-consts";
import "./SubscriptionAgeNotOkLightAlert.less";
const SubscriptionAgeNotOkLightAlert: FC<{ maxAgeAllowed?: number }> = ({ maxAgeAllowed }) => {
    if (!maxAgeAllowed) return null;

    return (
        <Notification className="subscription-age-not-ok" type="tile" variant="warning">
            <Notification.Icon name="info" />
            <Notification.Heading>Obs!</Notification.Heading>
            <Notification.Text>
                {MAX_AGE_BARN < maxAgeAllowed && maxAgeAllowed <= MAX_AGE_UNG && TEXT.AGE_RESTRICTION.SUBSCRIPTION_UNG}
                {maxAgeAllowed <= MAX_AGE_BARN && (
                    <>
                        {TEXT.AGE_RESTRICTION.SUBSCRIPTION_BARN}
                        <br />
                    </>
                )}
            </Notification.Text>
        </Notification>
    );
};

export default SubscriptionAgeNotOkLightAlert;
